import { render, staticRenderFns } from "./alert-settings.vue?vue&type=template&id=6a83c910&"
import script from "./alert-settings.vue?vue&type=script&lang=tsx&"
export * from "./alert-settings.vue?vue&type=script&lang=tsx&"
import style0 from "./alert-settings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports